export enum ProjectField {
  DESCRIPTION = "description",
  LINK = "link",
}
